import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getHighDemadItems } from "../../reducers/adminReducers";
import Loader from "../loader/loader";
import ListDatatable from "./listdatatable";
const HighDemandDetection = () => {
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);
  const [loading, setLoading] = useState(false);
  const { highDemandItems } = result || {};
  useEffect(() => {
    setLoading(true);
    dispatch(getHighDemadItems());
    setLoading(false);
  }, [dispatch]);

  return (
    <Fragment>
      <Breadcrumb title="High Demand" parent="Product" />
      <Container fluid={true}>
        <div className="admin-card">
          <Card>
            <CardHeader>
              <h5>Demand Detection</h5>
            </CardHeader>
            <CardBody>
              <div className="clearfix"></div>
              <div
                id="batchDelete"
                className="category-table user-list order-table coupon-list-delete">
                {!loading ? (
                  highDemandItems?.length > 0 && (
                    <ListDatatable
                      multiSelectOption={true}
                      myData={highDemandItems}
                      pageSize={10}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  )
                ) : (
                  <Loader />
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
    </Fragment>
  );
};

export default HighDemandDetection;
